import Contact from '../Contact/contact';
import GenericModel from '../generic-model';
import HeightEquipment from '../height-equipment';
import LoggedAction from '../logged-action';
import ProductAsset from '../product-asset';
import Employee from '../product/employee';
import SecondBoard from '../product/ip-board/second-board';
import RegisteredAction from '../registered-action';
import Address from './address';
import { AddressType } from './address-with-type';
import { SubProject } from './sub-project';

export class ProjectPlacement extends GenericModel {
  project?: SubProject;
  address?: Address;
  hasPictureOfLocationDescription?: boolean;
  appointment?: boolean;
  appointmentWithCustomer?: boolean;
  appointmentName?: string;
  appointmentPhoneNumber?: string;
  appointmentEmail?: string;
  appointmentContact?: Contact;
  appointmentDate?: Date;
  appointmentTime?: Date;
  extraInfoAppointment?: string;
  appointmentTimeOfDay?: string;
  firstAppointment?: boolean;
  appointmentFollowUp?: string;
  appointmentFollowUpEmployee?: Employee;
  appointmentFollowUpDate?: Date;
  appointmentReady?: boolean;
  appointmentReadyRegistration?: LoggedAction;
  appointmentFailure?: boolean;
  appointmentFailureRegistration?: LoggedAction;
  collectKey?: boolean;
  collectKeyMailSendRegistration?: LoggedAction;
  collectKeyFrom?: number;
  collectKeyAddressType?: AddressType;
  collectKeyExtraInfo?: string;
  contactName?: string;
  contactPhone?: string;
  keyAvailable?: boolean;
  extraInfoKey?: string;
  siteVisit?: boolean;
  siteVisitExecuted?: boolean;
  siteVisitFeedback?: string;
  siteVisitExecutedRegistration?: LoggedAction;
  extraInfoSiteVisit?: string;
  deadlineSiteVisit?: Date;
  employee?: Employee;
  placers?: Employee[];
  charge?: boolean;
  extraInfoAddress?: string;
  extraSiteVisitNeedInfo?: string;
  extraInfoSite?: string;
  projectPlacementAssets?: ProductAsset[];
  placementFloor?: string;
  needAppointmentInfo?: string;
  extraPlacementInfo?: string;
  placeASAP?: boolean;
  placementEarliestDate?: Date;
  secondBoard?: SecondBoard;
  otherOrderPlacementInfo?: string;

  // CURRENTLY ONLY FOR ADJUSTMENTS
  actualPlacementDate?: Date;
  doLocationVerification?: boolean;
  currentPlacementDateConfirmed?: boolean;
  placeInstructions?: string;
  soldRentedStickerWorkHeight?: number;
  heightEquipment?: HeightEquipment;
  obstaclesPresent?: boolean;
  obstaclesInfo?: string;

  windowDamage?: boolean;
  extraInfoWindowDamage?: string;
  kilometersTo?: number;
  installerHourBudget?: number;
  installerMinuteBudget?: number;
  placerFeedback?: string;
  placementDone?: boolean;
  placementDoneExtraInfo?: string;
  placementDoneRegistration?: LoggedAction;
  locationVerificationExtraInfo?: string;
  locationVerified?: boolean;
  locationVerifiedRegistration?: LoggedAction;
  locationVerificationCheckedByExpert?: boolean;
  locationVerificationCheckedByExpertRegistration?: LoggedAction;
  undergroundPipework?: boolean;
  undergroundPipeworkText?: string;
  registeredActions?: RegisteredAction[];
  constructor() {
    super();
    this.placeASAP = true;
    this.appointment = false;
    this.collectKey = false;
  }
}
